import React from 'react';

const MachineMaster = () => {
    return <div>MachineMaster</div>;
    //Display machines list and give buttons to edit and delete
};

export default MachineMaster;
